import React, { useState, useEffect } from "react";
import "swiper/css";
// import { AboutList } from "./components/AboutList";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import AboutPlaceholder from "./components/placeholders/AboutPlaceholder";

const About = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isAboutLoading, setIsAboutLoading] = useState(true);
  const [about, setAbout] = useState(null);
  const params = useParams();

  useEffect(() => {
    setIsAboutLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/about/about-detail/${params.slug}/`
      )
      .then((res) => {
        setAbout(res.data);
      })
      .then(() => {
        setIsAboutLoading(false);
      });
  }, [params]);

  return (
    <div className="about-page py-5">
      {/* <AboutList currentSlug={about !== null ? about.slug : null} /> */}
      <div className="container mt-5">
        <div className="row">
          {isAboutLoading === true ? (
            <AboutPlaceholder />
          ) : (
            <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 m-auto">
              <h4 className="text-left fw-bold mb-4">
                {lang === "en"
                  ? about.name_en
                  : lang === "ru"
                  ? about.name_ru
                  : about.name_tm}
              </h4>
              <div
                className="about-content"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "en"
                      ? about.content_en
                      : lang === "ru"
                      ? about.content_ru
                      : about.content_tm,
                }}
              ></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default About;
